/**
 * Generic error messages for user-facing error pages
 * These messages are designed to be professional and user-friendly
 * while obfuscating technical details from non-technical users
 */

export interface ErrorMessage {
    title: string
    message: string
}

export interface ErrorMessages {
    [key: number]: ErrorMessage
}

/**
 * Generic error messages mapped by HTTP status code
 */
export const ERROR_MESSAGES: ErrorMessages = {
    404: {
        title: 'Page Not Found',
        message:
            "We couldn't find the page you're looking for. The page may have been moved or the link may be outdated. Please check the URL or return to the home page.",
    },
    500: {
        title: 'Something Went Wrong',
        message:
            "We're experiencing technical difficulties on our end. Our team has been notified and is working to resolve the issue. Please try again in a few moments.",
    },
}

/**
 * Default error message for unhandled error codes
 */
export const DEFAULT_ERROR_MESSAGE: ErrorMessage = {
    title: 'An Error Occurred',
    message:
        'Something unexpected happened. Please try again or contact support if the problem persists.',
}

/**
 * Get a user-friendly error message for the given status code
 * @param statusCode - HTTP status code
 * @returns User-friendly error message object
 */
export function getErrorMessage(statusCode?: number): ErrorMessage {
    if (statusCode && ERROR_MESSAGES[statusCode]) {
        return ERROR_MESSAGES[statusCode]
    }
    return DEFAULT_ERROR_MESSAGE
}
